import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest
} from 'utils/http'

export const getDevPlanApi = () => {
  return getRequest(`/development-plans?filter=this-week`)
}

export const getStats = query => {
  const { queryKey } = query
  return getRequest(
    `/development-plans/statistics?filter=${
      queryKey[1].filterData || 'this-week'
    }`
  )
}

export const editStepsApi = payload => {
  return putRequest('/development-plans', payload)
}

export const addPlanGoalApi = payload => {
  return postRequest('/development-plans/goals', payload)
}

export const deletePlanGoalApi = planId => {
  return deleteRequest(`/development-plans/goals/${planId}`)
}

export const editStepRateApi = payload => {
  const { planId, stepId, rate } = payload
  return putRequest(
    `/development-plans/goals/${planId}/action-steps/${stepId}/rate`,
    { rate: rate === null ? null : Number(rate) }
  )
}

export const reorderGoalsApi = orderedGoalIds => {
  return putRequest('/development-plans/goals/reorder', {
    orderedGoalIds
  })
}

export const editPlanGoalApi = async payload => {
  const {
    title,
    planId,
    addedSteps,
    editedSteps,
    deletedSteps,
    orderedStepIds = []
  } = payload

  // Apply edits and deletes first.
  await Promise.all([
    ...editedSteps.map(step =>
      putRequest(
        `/development-plans/goals/${planId}/action-steps/${step.id}`,
        { description: step.description }
      )
    ),
    ...deletedSteps.map(step =>
      patchRequest(
        `/development-plans/goals/${planId}/action-steps/${step.id}/delete`
      )
    )
  ])

  await putRequest(`/development-plans/goals/${planId}`, {
    title
  })

  // Create new steps, then map their temporary client ids to the real ids.
  const tempToRealId = {}
  if (addedSteps.length) {
    const addResponse = await postRequest(
      `/development-plans/goals/${planId}/action-steps/`,
      { actionSteps: addedSteps.map(step => step.description) }
    )
    const createdSteps = addResponse?.actionSteps || []
    addedSteps.forEach((step, index) => {
      if (createdSteps[index])
        tempToRealId[step.id] = createdSteps[index].id
    })
  }

  // Persist the final display order using real ids.
  if (orderedStepIds.length) {
    const orderedActionStepIds = orderedStepIds.map(id =>
      tempToRealId[id] != null ? tempToRealId[id] : id
    )
    await putRequest(
      `/development-plans/goals/${planId}/action-steps/reorder`,
      { orderedActionStepIds }
    )
  }

  return { success: true }
}
